<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center">
          <b-img
            fluid
            :src="sideImg"
            alt="SideImageProductCatalog"
            style="
              width: 100%;
              position: relative;
              top: 0;
              left: 0;"
          />
          <b-img
            :src="centerIcon"
            alt="ProductCatalog"
            style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 30%;"
          />

        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex  auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold d-flex justify-content-center mb-1"
          >
            <b-img
              :src="loginIcon"
              style="width: 50px;"
            />
          </b-card-title>
          <b-card-text class="mb-2 text-center">
            Welcome to Product Catalog
          </b-card-text>
          <div class="text-center font-weight-bold">
            LOGIN
          </div>
          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="validationForm"
            >
              <!-- username -->
              <b-form-group
                label="Username"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  rules="required"
                >
                  <b-form-input
                    id="login-username"
                    v-model="userUsername"
                    :state="errors.length > 0 ? false:null"
                    type="text"
                    name="login-username"
                    placeholder="Username / NIK"
                    autocapitalize="none"
                    autocomplete="off"
                    autocorrect="off"
                    spellcheck="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="d-flex justify-content-center align-items-center" style="width: 100%;">
                <img class="mr-1" :src="captcha" height="60px" width="auto"/>
                <feather-icon
                  style="height: 22px; width: 22px;"
                  class="cursor-pointer"
                  icon="RefreshCwIcon"
                  @click="fetchCaptcha()"
                />
              </div>
              <b-form-group
                label="Captcha"
                label-for="captcha"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Captcha"
                  rules="required"
                >
                  <b-form-input
                    id="captcha"
                    v-model="captchaInput"
                    :state="errors.length > 0 ? false:null"
                    type="text"
                    name="captcha"
                    placeholder="Captcha"
                    autocapitalize="none"
                    autocomplete="off"
                    autocorrect="off"
                    spellcheck="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit buttons -->
              <b-overlay
                :show="login_loading"
                rounded="sm"
              >
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="login_loading"
              >
                LOGIN
              </b-button>
              </b-overlay>
            </b-form>
          </validation-observer>


        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BOverlay
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BOverlay
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userUsername: '',
      passwordFieldType: 'password',
      sideImg: require('@/assets/images/bg-06.png'),
      icon: require('@/assets/images/logo-06 - Copy.png'),
      // centerIcon: require('@/assets/images/Prod.png'),
      // loginIcon: require('@/assets/images/New-Login-Logo.png'),
      // validation rulesimport store from '@/store/index'
      required,
      login_loading: false,
      login_cs_email: '',
      login_cs_phone: '',
      key: null,
      captcha: null,
      captchaInput: '',
      captchaIntervalId: null
    }
  },
  mounted() {
    this.getLoginCS()
    this.fetchCaptcha()
    this.startCaptchaAutoRefresh()
  },
  beforeDestroy() {
    this.stopCaptchaAutoRefresh()
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/bg-06.png')
        return this.sideImg
      }
      return this.sideImg
    },
    centerIcon() {
      return '/img/logo-06.png'   
    },
    loginIcon() {
       return this.$store.state.app.settings.logo.loginLogo ?? '/img/logo-06.png'   
    },
    login_cs_phone_sanitized() {
      return this.login_cs_phone.replace(/^0/, "62")
    }
  },
  methods: {
    validationForm() {
      if (this.login_loading) return
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.login()
        }
      })
    },
    async login() {
      if (this.login_loading) return
      if (!this.key) {
        await this.fetchCaptcha()
        this.$notif('Login Error', 'Captcha belum siap, silakan ulangi.', 'danger')
        return
      }
      this.login_loading = true;
      try {
        const res = await this.$http.post('/login', {
          username: this.userUsername,
          password: this.password,
          key: this.key,
          captcha: this.captchaInput.trim()
        });

        const accessToken = res?.data?.data?.token?.access_token;
        if (!accessToken) {
          throw new Error('No access token returned from login');
        }

        const payloadToken = [
          { type: 'type', value: 'Bearer' },
          { type: 'token', value: accessToken }
        ];
        this.$store.commit('oauth/setToken', payloadToken);

        localStorage.setItem('token', accessToken);

        this.$http.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

        let userRes;
        try {
          userRes = await this.$store.dispatch('oauth/getAuthUser');
        } catch (getAuthErr) {
        }

        const account = userRes?.account?.me;
        if (account) {
          this.$store.commit('oauth/setUser', { type: 'id', value: account.KODE });
          this.$store.commit('oauth/setUser', { type: 'name', value: account.NAME });
          this.$store.commit('oauth/setUser', { type: 'email', value: account.EMAIL_ADDRESS });
          this.$store.commit('oauth/setUser', { type: 'permissions', value: account.permissions });
          this.$store.commit('oauth/setUser', { type: 'role', value: account.role });
          this.$store.commit('oauth/setUser', { type: 'avatar', value: account.avatar });
        }

        this.$notif('Login Success', 'Login success', 'success');

        if (this.$route?.query?.location) {
          const pathname = decodeURIComponent(this.$route.query.location);
          this.$router.push(pathname);
        } else {
          this.$router.push({ name: 'home' });
        }
      } catch (err) {
        const data = err?.data ?? err?.response?.data ?? {};
        const code = data?.exception?.code ?? '';
        const description = data?.exception?.description ?? '';
        const captchaError = data?.errors?.captcha ?? undefined;

        if (code === 'NotPermitted.Login.UserIsPeniunan') {
          const message = `Halo, saya tidak dapat login pada web product catalog dengan username *${this.userUsername}*. Mohon bantuannya, terima kasih.`;
          this.$swal({
            title: 'NIK tidak terdaftar!',
            html: `
              NIK tidak terdaftar, silahkan hubungi
              <a href="mailto:${this.login_cs_email}">${this.login_cs_email}</a> dan 
              <a href="https://api.whatsapp.com/send?phone=${this.login_cs_phone_sanitized}&text=${encodeURIComponent(message)}"> ${this.login_cs_phone} </a>
            `,
            icon: 'warning',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
          });
        } else if (code === 'NotPermitted.Login.MaximumAttempt') {
          this.$notif('Login Exceed Maximum Attempt', description, 'danger');
        } else if (captchaError) {
          this.$notif('Login Error', 'Captcha has expired. Please refresh and try again.', 'danger');
        } else {
          this.$notif('Login Error', 'Username or password is incorrect.', 'danger');
        }

        this.fetchCaptcha();
      } finally {
        this.login_loading = false;
      }
    },

    async getLoginCS() {
      return await this.$http.get('/settings/contact?login_cs=true')
      .then(res => {
        let data = res.data.data
        if (data.length > 0) {
          let [user] = data
          this.login_cs_email = user.EMAIL_CONTACT_US
          this.login_cs_phone = user.PHONE_CONTACT_US
        }
      })
      .catch(err => console.error(err))
    },
    fetchCaptcha() {
      return this.$http.get('/captcha')
        .then(res => {
          const { key, img: captcha } = res.data
          this.$set(this, 'key', key)
          this.$set(this, 'captcha', captcha)
          this.captchaInput = ''
        })
    },
    startCaptchaAutoRefresh() {
      if (this.captchaIntervalId) return
      this.captchaIntervalId = setInterval(() => {
        this.fetchCaptcha()
      }, 30000)
    },
    stopCaptchaAutoRefresh() {
      if (!this.captchaIntervalId) return
      clearInterval(this.captchaIntervalId)
      this.captchaIntervalId = null
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
